var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsBellFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56529_1844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99506 1.09904C8.99826 1.06646 8.9999 1.03342 8.9999 1C8.9999 0.447715 8.55219 0 7.9999 0C7.44762 0 6.9999 0.447715 6.9999 1C6.9999 1.03342 7.00154 1.06646 7.00474 1.09904C4.72009 1.56044 2.9999 3.57933 2.9999 6V7.92893C2.9999 9.25501 2.47312 10.5268 1.53543 11.4645L0.707007 12.2929C0.0770423 12.9229 0.52321 14 1.41411 14L5.9999 14C5.9999 15.1046 6.89533 16 7.9999 16C9.10447 16 9.9999 15.1046 9.9999 14L14.5857 14C15.4766 14 15.9228 12.9229 15.2928 12.2929L14.4644 11.4645C13.5267 10.5268 12.9999 9.25501 12.9999 7.92893V6C12.9999 3.57933 11.2797 1.56043 8.99506 1.09904Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56529_1844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBellFilled);
export default __webpack_public_path__ + "static/media/notificationsBellFilled.3fcb27c5.svg";
export { ForwardRef as ReactComponent };